import React from 'react';

import Input from '../Input';

import css from './index.css';

const  ContactInfoFromWrap = (props) => (
  <div className={css.formWrap}>
    <form >
      <Input
        mods={['floatRigt', 'strench', 'clearFix']}
        readonly
        title={'Email'}
        label={'email'}
        type='text'
        defaultValue={props.contactInfo.email}
        fnChange={props.handleChange}
        fnBlur={props.handleBlur}
        error={props.errorControl.email ? props.errorControl.email.error : ''}
      />
      <Input
        mods={['floatLef', 'half']}
        title={'First Name'}
        label={'basicFirstName'}
        type='text'
        defaultValue={props.contactInfo.basicFirstName}
        fnChange={props.handleChange}
        fnBlur={props.handleBlur}
        error={props.errorControl.basicFirstName ? props.errorControl.basicFirstName.error : ''}
      />
      <Input
        mods={['floatRigt', 'half']}
        title={'Last Name'}
        label={'basicLastName'}
        type='text'
        defaultValue={props.contactInfo.basicLastName}
        fnBlur={props.handleBlur}
        fnChange={props.handleChange}
        error={props.errorControl.basicLastName ? props.errorControl.basicLastName.error : ''}
      />
      <Input
        mods={['floatLef', 'half']}
        title={'Phone'}
        label={'basicPhone'}
        type='phone'
        defaultValue={props.contactInfo.basicPhone}
        fnBlur={props.handleBlur}
        fnChange={props.handleBlur}
        error={props.errorControl.basicPhone ? props.errorControl.basicPhone.error : ''}
      />
      <Input
        mods={['floatRigt', 'half']}
        title={'Company'}
        label={'basicCompany'}
        type='text'
        defaultValue={props.contactInfo.basicCompany}
        fnBlur={props.handleBlur}
        fnChange={props.handleChange}
        error={props.errorControl.basicCompany ? props.errorControl.basicCompany.error : ''}
      />
      <Input
        mods={['floatLef', 'half']}
        title={'DOT'}
        label={'basicDot'}
        type='dot'
        defaultValue={props.contactInfo.basicDot}
        fnChange={props.handleBlur}
        fnBlur={props.handleDotMcBlur}
        error={props.errorControl.basicDot ? props.errorControl.basicDot.error : ''}
      />
      <Input
        mods={['floatRigt', 'half']}
        title={'MC'}
        type='mc'
        label={'basicMc'}
        defaultValue={props.contactInfo.basicMc}
        fnChange={props.handleBlur}
        fnBlur={props.handleDotMcBlur}
        error={props.errorControl.basicMc ? props.errorControl.basicMc.error : ''}
      />
      <Input
        mods={['floatRigt', 'strench', 'clearFix']}
        title={'New Password'}
        label={'new_password'}
        type='password'
        fnBlur={props.handleBlur}
        fnChange={props.handleChange}
        error={props.errorControl.new_password ? props.errorControl.new_password.error : ''}
      />
      <Input
        mods={['floatRigt', 'strench', 'clearFix']}
        title={'Confirm new password'}
        label={'confirm_password'}
        type='password'
        fnBlur={props.handleBlur}
        fnChange={props.handleChange}
        error={props.errorControl.confirm_password ? props.errorControl.confirm_password.error : ''}
      />
    </form>
  </div>);

export default ContactInfoFromWrap;





// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/share/ContactInfoFormForWelcomecomeWarp/index.js